exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "polyline[data-v-0f28e295]{\n  fill:none;\n  stroke-linecap:round;\n  stroke-linejoin:round\n}", ""]);

// exports
